module.exports = __webpack_public_path__ + "static/img/yinliangjian2.40f19aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/yinliangjian2.png
// module id = +19a
// module chunks = 24